import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { NotFoundContainer } from './Style';
import { Link } from 'react-router-dom';
import background from '../../../Assets/images/background.svg';

const NotFound: React.FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();
  const style = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPositionY: 'center',
    backgroundPositionX: 'center',
    backgroundAttachment: 'fixed',
    minHeight: 'calc(100vh - 62px)',
  };

  return (
    <NotFoundContainer style={style}>
      <div>
        <h1>404</h1>
        <h2>{t('Page not found')}</h2>
        <Link to="/courses">{t('Go to courses page')}</Link>
      </div>
    </NotFoundContainer>
  );
};

export default NotFound;
